<template>
    <div>
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        
        <div v-if="congratulation_module"> 
            <div class="middleBox whitebox border radius  mb-3"> 
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/check.svg" alt="Congratulations">
                    </div>
                    <div class="subtitle">
                        <h3> {{$t('congo')}} <span class="green">{{get_user.profile.firstname}} {{get_user.profile.lastname}}</span></h3>
                        <p> {{$t('createAccountMsz1')}}</p>
                        <ul class="includeWdth">
                            <li><strong> {{$t('tradingId')}}</strong> {{account_detail.account_id}} </li>
                            <li><strong> {{$t('password')}}</strong>{{firstChar(account_detail.password)}}</li>
                            <li><strong> {{$t('leverage')}}</strong> {{account_detail.leverage}}</li>
                            <li><strong> {{$t('accountBaseCurrency')}}</strong> {{account_detail.currency}}</li>
                        </ul>
                    </div>
                </div> 
                <div class="full-width  submitButton align-items-center justify-content-center d-flex mt-3 w-100">
                    <a class="prism_btn btn_sm darkBG mr-3" href="#" @click.prevent="congratulation_module = false; reset();">Back</a>
                    <a href="http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245" class="prism_btn btn_sm"  target="_blank" v-if="platform == 'ACT'"> {{$t('tradeNow')}}</a>
                    <router-link :to="'/new-web-trade-link'" target="_blank" v-else-if="platform.toUpperCase() == 'mt4'" class="prism_btn btn_sm">{{$t('tradeNow')}}</router-link>
                    <router-link :to="{path : '/web-trade-link',query:{'platform': platform.toUpperCase()}}" target="_blank" class="prism_btn btn_sm" v-else>{{$t('tradeNow')}}</router-link>
                </div> 
            </div>
            <div class="middleBox whitebox border radius mb-5">
                <div class="text-center innerTitle pb-3 mb-3">
                    <h2> {{$t('download')}} {{platform}}</h2>
                </div>
                <div class="downloadPlatform d-flex align-items-center">
                    <div class="dpBox d-flex align-items-center">
                        <a :href="platformJson[platform].window" target="_blank">
                            <div class="ico">
                                <img src="../../../../static/fxView/images/windows.svg" alt="">
                            </div>
                            <div class="desc">
                                <p> {{$t('forWindows')}}
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="dpBox d-flex align-items-center">
                        <a :href="platformJson[platform].ios" target="_blank">
                            <div class="ico">
                                <img src="../../../../static/fxView/images/ios.svg" alt="">
                            </div>
                            <div class="desc">
                                <p>{{$t('forIos')}}
                                </p>
                            </div>
                         </a>
                    </div>
                    <div class="dpBox d-flex align-items-center">
                        <a :href="platformJson[platform].android" target="_blank">
                            <div class="ico">
                                <img src="../../../../static/fxView/images/android.svg" alt="">
                            </div>
                            <div class="desc">
                                <p>{{$t('forAndroid')}}
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="dpBox d-flex align-items-center">
                        <a :href="platformJson[platform].web" target="_blank" v-if="platform == 'ACT'">
                            <div class="ico">
                                <img src="../../../../static/fxView/images/android.svg" alt="">
                            </div>
                            <div class="desc">
                                <p>{{$t('forWeb')}}
                                </p>
                            </div>
                        </a>
                        <router-link :to="platformJson[platform].web" target="_blank" v-else>
                            <div class="ico">
                                <img src="../../../../static/fxView/images/webtrader.svg" alt="">
                            </div>
                            <div class="desc">
                                <p>{{$t('forWeb')}}
                                </p>
                            </div>
                        </router-link>
                    </div>
                </div> 
            </div> 
        </div> 
        <div v-else>  
            <div class="stepForm" v-if="(get_user.profile.firstname == ''  || get_user.profile.firstname == null) || (get_user.mobile_no == '' || get_user.mobile_no == null)">
                <div class="mainTitle text-center mt-4 mb-3">
                    <h3 class="mb-4"> {{$t('personalInfo')}}</h3>
                    <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                </div>  
                <div class="CustomBlockWidth inMiddle-area radius whitebox p-4">
                    <div class="form-group field-wrapper" v-if="get_user.profile.firstname == '' || get_user.profile.firstname == null">
                        <input placeholder=" " type="text" v-model="f_name"  v-validate="'required'" name="f_name" class="float-field form-control"  :class="{ 'is-invalid': personalInfoSubmitted && errors.has('f_name') }" ref="f_nameInput" />
                        <label for="password" class="float-label">{{$t('fname')}}</label>
                        <ul><li v-for="error in errors.collect('f_name')">{{ error }}</li></ul>
                    </div> 
                    <div class="form-group field-wrapper" v-if="get_user.profile.lastname == '' || get_user.profile.lastname == null"> 
                        <input placeholder=" " type="text" v-model="l_name" class="float-field form-control" v-validate="'required'" name="l_name"  :class="{ 'is-invalid': personalInfoSubmitted && errors.has('l_name') }" ref="l_nameInput" />
                        <label for="password"  class="float-label">{{$t('lname')}}</label>
                        <ul><li v-for="error in errors.collect('l_name')">{{ error }}</li></ul>
                    </div> 
                    <!-- <div class="form-group field-wrapper" v-if="get_user.profile.firstname == '' && get_user.mobile_no == ''"> 
                        <vue-phone-number-input v-model="mobile_no"  :no-example="true" :default-country-code="userCountry" v-validate="{ max:15 }" ref="mobile_noInput" :class="{ 'is-invalid': submitted && errors.has('mobile_no') }" name="mobile_no" @update="updatedText"/>
                        <ul><li v-for="error in errors.collect('mobile_no')">{{ error }}</li></ul>
                        <p class="error" v-if="!(numberValid)">{{$t('InvalidNumber')}}</p>
                    </div>   v-if="get_user.profile.firstname != '' && get_user.mobile_no == ''"-->
                    <div class="form-group field-wrapper" v-if="get_user.mobile_no == '' || get_user.mobile_no == null"> 
                        <vue-phone-number-input v-model="mobile_no"  :no-example="true" :default-country-code="userCountry" v-validate="{ required:true,max:15 }" ref="mobile_noInput" :class="{ 'is-invalid': submitted && errors.has('mobile_no') }" name="mobile_no" @update="updatedText"/>
                        <ul><li v-for="error in errors.collect('mobile_no')">{{ error }}</li></ul>
                        <p class="error" v-if="!(numberValid)">{{$t('InvalidNumber')}}</p>
                    </div> 
                    <div class="text-center">
                       <!--  <a href="#" v-if="get_user.profile.firstname != '' && get_user.mobile_no == ''" @click="mobileShowvar = false" class="mr-3">skip</a> -->
                        <button class="prism_btn btn_sm" v-on:click="submitPersonalInfo()"> {{$t('saveContinue')}}</button>
                    </div> 
                </div> 
            </div>
            <div class="stepForm" v-else>
                <div class="mainTitle text-center mt-4 mb-3">
                    <h3 class="mb-4"> {{$t('open')}} <span v-html="parseInt(demo_live_select) == 0? 'Demo' : 'Live'"></span> {{$t('tradingAcc')}} </h3>
                    <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                </div> 
                <div class="middleBox inMiddle-area radius whitebox p-4"> 
                    <h4 class="mb-2">Select Platform</h4>
                        <div class="row">
                            <div class="col-12 col-md-4 mb-3">
                                <div class="customFm  border">
                                    <label class="customRadio-button m-0"> {{$t('MT4')}}
                                        <input type="radio" name="Platform" value="MT4" v-model="platform" v-validate="'required'" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('Platform') }" ref="platformInput" @focus="platformInput">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <ul><li class="error mt-2">{{ errors.first('Platform') }}</li></ul>
                            </div>
                            <!-- <div class="col-12 col-md-4 mb-3">
                                <div class="customFm   border">
                                    <label class="customRadio-button m-0">{{$t('MT5')}}
                                        <input type="radio" name="Platform" value="MT5" v-model="platform" v-validate="'required'" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('Platform') }" ref="platformInput" @focus="platformInput">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div> -->
                            <div class="col-12 col-md-4 mb-4">
                                <div class="customFm   border">
                                    <label class="customRadio-button m-0"><p v-html="$t('actTrader')"></p>
                                        <input type="radio" name="Platform" value="ACT" v-model="platform" v-validate="'required'" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('Platform') }" ref="platformInput" @focus="platformInput">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div> 
                            
                            <div class="col-12 mb-3">
                                <div class="slctcurrency">
                                    <h4 class="mb-3"> {{$t('currency')}}</h4>
                                    <ul>
                                        <li :class="(select_currency == 'USD')?'selected':''" @click="chooseCurrency('USD')">
                                            <img src="../../../../static/fxView/images/usd.svg" alt="usd">
                                             {{$t('USD')}}
                                        </li>
                                        <li :class="(select_currency == 'EUR')?'selected':''" @click="chooseCurrency('EUR')">
                                            <img src="../../../../static/fxView/images/eur.svg" alt="eur">
                                             {{$t('EUR')}}
                                        </li>
                                        <li :class="(select_currency == 'GBP')?'selected':''" @click="chooseCurrency('GBP')">
                                            <img src="../../../../static/fxView/images/gbp.svg" alt="gbp">
                                             {{$t('GBP')}}
                                        </li>
                                        <!--<li :class="(select_currency == 'AUD')?'selected':''" @click="select_currency = 'AUD'">
                                            <img src="../../../../static/fxView/images/aud.svg" alt="aud">
                                             {{$t('AUD')}}
                                        </li>-->
                                    </ul> 
                                </div>
                            </div>
                            <div class="col-12 mb-3">
                                <input type="hidden" v-model="leverage" v-validate="'required'" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('leverage') }" ref="leverageInput" name="leverage">
                                <div class="slctcurrency" >
                                    <h4 class="mb-3"> {{$t('leverage')}}</h4>
                                    <ul>
                                        <li  :class="leverageDisabledFunc(key)" @click="handleLeverageEvent(key)"  v-html="$t('pro'+key)" v-for="(list,key) in leverageJsonPLCountry" v-if="getUserProfile.residence_country == 'PL'"> </li >
                                        <li  :class="leverageDisabledFunc(key)" @click="handleLeverageEvent(key)"  v-html="$t('pro'+key)" v-for="(list,key) in leverageJson" v-if="getUserProfile.residence_country != 'PL'"> </li >
                                        <!-- <li :class="(leverage == '30')?'selected':''" @click="leverage = '30'"  v-html="$t('X30')"> </li>
                                        <li :class="(leverage == '100')?'selected':''" @click="leverage = '100'" v-html="$t('pro100')"> </li>
                                        <li :class="(leverage == '200')?'selected':''" @click="leverage = '200'" v-html="$t('pro200')" v-if="getUserProfile.residence_country != 'PL'"> </li>
                                        <li :class="(leverage == '300')?'selected':''" @click="leverage = '300'" v-html="$t('pro300')" v-if="getUserProfile.residence_country != 'PL'"> </li>
                                        <li :class="(leverage == '400')?'selected':''" @click="leverage = '400'" v-html="$t('pro400')" v-if="getUserProfile.residence_country != 'PL'"> </li>
                                        <li :class="(leverage == '500')?'selected':''" @click="leverage = '500'" v-html="$t('pro500')" v-if="getUserProfile.residence_country != 'PL'"> </li> --> 
                                        
                                    </ul>
                                    <ul v-if="errors.first('leverage')"><li class="error">{{$t('leverageField')}}</li></ul>
                                </div>
                            </div> 
                            <div class="col-12 col-md-12 border-top pt-3 trading-acc-passwprd-row">
                                <div class="acPassword">
                                    <h3 class="mb-3"> {{$t('password')}}</h3>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group field-wrapper">
                                            <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{8,15}$/}"  name="Trading Account Password" :class="{ 'is-invalid': submitted && errors.has('Trading Account Password') }" ref="passwordInput" @keyup="testing()" v-if="platform == 'MT5'" @focus="handlePasswordEvent" />
                                            <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{5,15}$/}"  name="Trading Account Password" :class="{ 'is-invalid': submitted && errors.has('Trading Account Password') }" ref="passwordInput" @focus="handlePasswordEvent" @keyup="testing()" v-else />
                                            <label for="password" class="float-label"> {{$t('accountPassword')}}</label>
                                            <feather :type="iconType" class="toggle-password" @click="switchVisibility('1')"></feather>
                                            <p class="error" v-for="error in errors.collect('Trading Account Password')" v-if="!submitError">
                                                <span v-if="error == 'The Trading Account Password field is required.'">{{error}}</span>
												<span v-else-if="error == 'The Trading Account Password field format is invalid.'">
                                                    <span v-if="platform == 'MT5'">{{ $t("passwordMust").replace('6','8') }}</span>
                                                    <span v-else>{{ $t("passwordMust")  }}</span>
                                                </span>
											</p>
											<p class="error" v-if="submitError">
                                                <span >{{$t('passwordMust')}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group field-wrapper">
                                            <input :type="inputtype1" placeholder=" " v-model="confirmPassword" class="float-field form-control" v-validate="{ required: true,  confirmed:password}" name="confirmPassword" :class="{ 'is-invalid': submitted && errors.has('confirmPassword') }" ref="confirmPasswordInput" @focus="handlePasswordConfirmEvent">
                                            <label for="password" class="float-label"> {{$t('conPassword')}}</label>
                                            <feather :type="iconType1" class="toggle-password" @click="switchVisibility('2')"></feather> 
                                            <p class="error" v-for="error in errors.collect('confirmPassword')">
                                                <span v-show="error == 'The confirmPassword field is required.'">{{$t('confirmFieldReq')}}</span>
                                                <!-- <span v-show="error == 'The confirmPassword field format is invalid.'">{{$t('passwordContain')}}</span> -->
                                                <span v-show="error == 'The confirmPassword confirmation does not match.'">{{$t('newConfFieldSame')}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-12 col-md-12 mt-3">
                                <div class="full-width submitButton justify-content-center align-items-center  d-flex  mt-3 w-100">
                                    <button class="prism_btn btn_sm" v-on:click="submit()"> {{$t('createAccount')}} </button>
                                </div>
                            </div>
                        </div>
                    
                </div> 
            </div> 
        </div>            
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    export default {
        name: 'CREATE-ACCOUNT',
        mixins: [fxViewMixins],
        data() {
            return {
                mszValidation : '',
				submitError : false,
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                userCountry : 'IN',
                select_currency : 'EUR',
                account_type : 'ECN',
                platform : '',
                leverage : '',
                password : '',
                confirmPassword : '',
                error_msg_password : '',
                submitted : false,

                f_name : '',
                m_name : '',
                l_name : '',
                mobile_no : '',
                mobileShowvar : false,
                show_mob : true,
                personalInfoSubmitted : false,

                congratulation_module : false,
                account_detail : {},

                inputtype:'password',
                showpassword: false,
                iconType : 'eye-off',
                inputtype1:'password',
                showpassword1: false,
                iconType1 : 'eye-off',
                numberValid: true,
                demo_live_select : '0',
                numberWithCountry:'',
                platformJson : {
                    'MT5' : {
                        'window': 'https://download.mql5.com/cdn/web/fxview.uk.ltd/mt5/fxview5setup.exe' ,  
                        'ios': 'https://apps.apple.com/us/app/metatrader-5/id413251709' ,  
                        'android': 'https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5',
                        web: {path : '/web-trade-link',query:{'platform':'MT5'}}
                    },
                    'MT4' : {
                        'window': 'https://download.mql5.com/cdn/web/charlgate.ltd/mt4/fxview4setup.exe' ,  
                        'ios': 'https://download.mql5.com/cdn/mobile/mt4/ios?server=FxView-Demo,FxView-Live' ,  
                        'android': 'https://download.mql5.com/cdn/mobile/mt4/android?server=FxView-Demo,FxView-Live' ,
                        web: "/new-web-trade-link",
                    },
                    'ACT' : {
                        'window': 'http://setup.sysfx.com/setup/trader/fxview/trader_setup.exe' ,  
                        'ios': 'https://www.apple.com/ios/app-store/' ,  
                        'android': 'https://play.google.com/store/apps/details?id=fxview.trader' ,
                        'web': 'http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245'
                    }
                }
            }
        },
        
		methods:{
            chooseCurrency(e){
                this.select_currency = e;
                this.$trackEvent('CP+Demo+account+currency');
            },
            reset() {
                this.password = "";
                this.confirmPassword = "";
                this.leverage = "";
                this.select_currency = "";
                this.account_type = "";
                this.platform = "";
            },
            testing(){
				var specialArray = ['!','@','#','$','%','^','&','*','(',')','_','-','+','=','[',']','{','}',';',':','"','/','?','.','>','<','|','/','*',','];
				var specialArrayAccept = ['!','@','#','$','%','^','*','/']
				let truVar = ''
				
				for(let i=0 ; i<= this.password.length-1 ; i++){
					if(specialArray.indexOf(this.password[i]) > 0){
						if(specialArrayAccept.indexOf(this.password[i]) == -1){
							truVar = '1'
						}
					}
					
					if(i == this.password.length-1 ){
						if(truVar == '1'){
							this.submitError= true
						}else{
							this.submitError = false
						}
					}
				}
			},
            leverageDisabledFunc(getKey){
                if(parseInt(this.leverage) == parseInt(getKey)){
                    return 'selected' ;
                }else{
                    return '';
                }
            },
            updatedText(e){
                this.numberWithCountry = e.formattedNumber
                this.numberValid = e.isValid
            },
            firstChar(getPassword){
                let first =  getPassword.charAt(0)
                let last = getPassword.charAt(getPassword.length - 1)
                return first+'*****'+last; 
            },
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
                
            },
            ...mapActions({
                _runSaveUserName: types.RUN_SAVE_USER_NAME
            }),
            submitPersonalInfo(){
                const _that = this
                _that.personalInfoSubmitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let inputJson={
                            'globalParams' : {
                                'fname' :_that.f_name,
                                'mname' : _that.m_name,
                                'lname' : _that.l_name,
                                'mobile_no' : _that.numberWithCountry
                            },
                            'localParams' : {'parameter' : _that}
                        }
                        _that._runSaveUserName(inputJson)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submit(){
                this.$trackEvent('CP+Demo+account+Create+account');
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid && !_that.submitError) {
                        let accountJson={
                            'globalParams' : {
                                'currency' :_that.select_currency,
                                'account_type' : _that.account_type,
                                'platform' : _that.platform,
                                'leverage' : _that.leverage,
                                'password' : _that.password,
                                'demo_live' : _that.demo_live_select.toString(),
                            },
                            'localParams' : {'parameter' : _that}
                        }
                        _that._runCreateAccount(accountJson)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                        let list = _that.errors.items.filter(v=>v.rule != "required").map(v=>v.msg)
                        if(list.length){
                            try {
                                window.dataLayer.push({
                                    'event' : 'error',
                                    'errorType': 'create demo tading account error',
                                    'errorMessage': list.join(',').replace('The password field format is invalid.',this.$t('passwordMust'))
                                });
                            } catch (ex) {
                                console.log('ex', ex)
                            }
                        }
                    }
                });
            },
            platformInput(){
                this.$trackEvent('CP+Demo+account+Platform');
            },
            handlePasswordEvent(){
                this.$trackEvent('CP+Demo+account+Password');
            },
            handlePasswordConfirmEvent(){
                this.$trackEvent('CP+Demo+account+Confirm+Password'); 
            },
            handleLeverageEvent(key){
                this.leverage = key
                this.$trackEvent('CP+Demo+account+Leverage'); 
            }
            
        },
        mounted(){
            const _that = this;
            $(".costompopup .creat-account").click(function(){
                _that.congratulation_module = false
            });

            const leverageInput = this.$refs.leverageInput;
            leverageInput.addEventListener('focus', () => {
                this.$trackEvent('CP+Demo+account+Leverage'); 
            });
            
        },
        created(){
            this.$trackEvent('CP+Demo+account+Pageview');
            if(this.get_user.pro_user != 1){
                this.leverage = '30'
            }
            if(this.get_user.profile.firstname != '' && this.get_user.profile.firstname != null){
                this.f_name =  this.get_user.profile.firstname
            }
            if(this.get_user.profile.lastname != '' && this.get_user.profile.lastname != null){
                this.l_name =  this.get_user.profile.lastname
            }
            
            if(this.get_user.mobile_no != '' && this.get_user.mobile_no != null){
                this.mobile_no =  this.get_user.mobile_no
            }else{
                this.mobileShowvar = true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/create_account.vue